// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"774":"9e922dd74c53cb57","939":"0ee3773f91eb60c1"}[chunkId] + ".js";
};